import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface ClearEmailVerificationResponse extends BackendResponse {}
export interface ClearEmailVerificationParameters extends NextApiParams {}

export const clearEmailVerification = withNextApi<
  ClearEmailVerificationResponse,
  ClearEmailVerificationParameters
>("/cvp/CvpClearEmailVerification");
